/**
 * Vehicle label helpers for displaying vehicle types and subtypes
 * Shared across VehicleSettings and OptimizationList
 */

/** Keep unregistered equipment identifiable without inventing a registration. */
export function getVehicleDisplayName(vehicle: { id?: string; registration_number?: string | null; type?: string; vehicle_subtype?: string | null }): string {
  if (vehicle.registration_number?.trim()) return vehicle.registration_number.trim()
  const label = vehicle.vehicle_subtype ? getVehicleSubtypeLabel(vehicle.vehicle_subtype) : getVehicleTypeLabel(vehicle.type)
  return `${label} · ${vehicle.id ? `#${vehicle.id}` : 'Sans immatriculation'}`
}

export const VEHICLE_TYPE_LABELS: Record<string, string> = {
    TRUCK: 'Tracteur',
    RIGID_TRUCK: 'Porteur rigide',
    VAN: 'Fourgonnette',
    TRAILER: 'Remorque',
    SEMI_TRAILER: 'Semi-remorque',
    CONTAINER: 'Conteneur',
    OTHER: 'Autre'
}

export function getVehicleTypeLabel(type: string | undefined): string { return type ? VEHICLE_TYPE_LABELS[type] || type : '-' }

export const VEHICLE_SUBTYPE_LABELS: Record<string, string> = {
    // Porteurs rigides
    'porteur_2_essieux_12t': 'Porteur 2 essieux 12t',
    'porteur_2_essieux_18t': 'Porteur 2 essieux 18t',
    'porteur_3_essieux_26t': 'Porteur 3 essieux 26t',
    // Tracteurs
    'tracteur_4x2': 'Tracteur 4x2',
    'tracteur_6x2': 'Tracteur 6x2',
    // Semi-remorques
    'semi_remorque_2_essieux_34t': 'Semi-remorque 2 essieux 34t',
    'semi_remorque_3_essieux_44t': 'Semi-remorque 3 essieux 44t',
    // Remorques
    'remorque_2_essieux': 'Remorque 2 essieux',
    'remorque_3_essieux': 'Remorque 3 essieux',
    // Fourgonnettes
    'fourgonnette_standard': 'Fourgonnette standard',
    // Conteneurs
    'dry_20': 'Dry 20ft',
    'dry_40': 'Dry 40ft',
    'dry_45': 'Dry 45ft',
    'high_cube_40': 'High Cube 40ft',
    'high_cube_45': 'High Cube 45ft',
    'reefer_20': 'Reefer 20ft',
    'reefer_40': 'Reefer 40ft',
    'open_top_20': 'Open Top 20ft',
    'open_top_40': 'Open Top 40ft',
    'flat_rack_20': 'Flat Rack 20ft',
    'flat_rack_40': 'Flat Rack 40ft',
    'tank_20': 'Tank 20ft',
    'tank_40': 'Tank 40ft'
}

export function getVehicleSubtypeLabel(subtype: string | undefined): string { return subtype ? VEHICLE_SUBTYPE_LABELS[subtype] || subtype : '-' }

/** Resolve visible French labels into enum matches; the server applies the OR before pagination. */
export function vehicleSearchAliases(search: string) {
  const query = search.trim().toLocaleLowerCase('fr-FR')
  const matches = (labels: Record<string, string>) => Object.entries(labels).filter(([, label]) => query && label.toLocaleLowerCase('fr-FR').includes(query)).map(([key]) => key).join(',')
  return { searchTypes: matches(VEHICLE_TYPE_LABELS), searchSubtypes: matches(VEHICLE_SUBTYPE_LABELS) }
}
